"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'Carousel',
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    bannerPadding: function bannerPadding() {
      if (!this.propsData.bannerPadding) {
        return '';
      }
      return "".concat(this.propsData.bannerPadding.pt || 0, "px ").concat(this.propsData.bannerPadding.pr || 0, "px ").concat(this.propsData.bannerPadding.pb || 0, "px ").concat(this.propsData.bannerPadding.pl || 0, "px");
    },
    bannerWidth: function bannerWidth() {
      var _ref = this.propsData || {},
        _ref$bannerHeight = _ref.bannerHeight,
        bannerHeight = _ref$bannerHeight === void 0 ? 160 : _ref$bannerHeight;
      return "".concat(bannerHeight || 160, "px");
    }
  }
};